import type useWithdrawInventory from '@/application/write/positions/useWithdrawInventory';
import useWithdrawInventoryQuote from '@/application/read/positions/useWithdrawInventoryQuote';
import Icon, { Icons } from '@/presentation/components/elements/Icon';
import {
  ActionItem,
  ActionList,
  renderApproveContracts,
} from '@/presentation/components/modules/ActionList';
import { TransactionState, useNetwork } from '@nftx/react';
import { Address, InventoryPosition, TokenId } from 'nftx.js';

const WithdrawInventoryProcessing = ({
  onCancel,
  onComplete,
  percentageToWithdraw,
  position,
  symbol,
  tokenIds,
  userAddress,
  withdraw,
  status,
  error,
}: {
  percentageToWithdraw: number;
  position: InventoryPosition;
  tokenIds: [TokenId, number][];
  userAddress: Address;
  symbol: string;
  onCancel: () => void;
  onComplete: () => void;
  status: TransactionState;
  error: any;
  withdraw: ReturnType<typeof useWithdrawInventory>[0];
}) => {
  const network = useNetwork();
  const { data: quote } = useWithdrawInventoryQuote({
    percentageToWithdraw,
    tokenIds,
    positionId: position.id,
  });
  if (!quote) {
    return (
      <div className="p-6 bg-gray-50 w-full flex justify-center items-center">
        <Icon name={Icons.SPINNER_GAP} className="animate-spin" />
      </div>
    );
  }
  const action = () => {
    withdraw({ quote, userAddress });
  };

  const actionItems: JSX.Element[] = [];
  actionItems.push(
    ...renderApproveContracts({
      approveContracts: quote.approveContracts,
      index: 0,
      network,
      symbol,
    })
  );
  actionItems.push(
    <ActionItem
      index={1}
      label="Withdraw inventory"
      status={status}
      error={error}
      action={action}
    />
  );

  return (
    <ActionList
      title="Remove Inventory"
      description="Any unclaimed rewards will be included"
      onCancel={onCancel}
      onComplete={onComplete}
    >
      {actionItems}
    </ActionList>
  );
};

export default WithdrawInventoryProcessing;
